var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFootball(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.2,98.7l25.4-25.4L47.4,66L22,91.5c-2,2-2,5.3,0,7.3C24,100.8,27.2,100.8,29.2,98.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5,75.1L9.2,122.4c-2,2-2,5.3,0,7.3c2,2,5.3,2,7.3,0l47.2-47.2L56.5,75.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6,34.7c2.5,0,4.7-1,6.4-2.6c1.6-1.6,2.6-3.9,2.6-6.4s-1-4.7-2.6-6.4c-1.6-1.6-3.9-2.6-6.4-2.6c-2.5,0-4.7,1-6.4,2.6 c-1.6,1.6-2.6,3.9-2.6,6.4s1,4.7,2.6,6.4C78.8,33.7,81.1,34.7,83.6,34.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.2,38.6H49.5c-1.3,0-2.6,0.5-3.6,1.5L31.4,54.6c-2,2-2,5.3,0,7.3c2,2,5.3,2,7.3,0l13-13h12.9L51,62.4l16.3,16.4 l29.9-29.9h33.9c2.8,0,5.1-2.3,5.1-5.1C136.4,40.9,134,38.6,131.2,38.6z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59.1,113.3c4.2,0,7.6,3.4,7.6,7.6s-3.4,7.6-7.6,7.6c-4.2,0-7.6-3.4-7.6-7.6S55,113.3,59.1,113.3 M59.1,110.6 c-5.7,0-10.3,4.6-10.3,10.3s4.6,10.3,10.3,10.3s10.3-4.6,10.3-10.3C69.4,115.2,64.8,110.6,59.1,110.6L59.1,110.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootball);
export default __webpack_public_path__ + "static/media/football.8d5523773ae1f18059658560c1d469b8.svg";
export { ForwardRef as ReactComponent };